<footer class="footer">
  <div class="footer-wave">
    <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
      <path d="M0,40 C360,100 720,0 1440,60 L1440,100 L0,100 Z" fill="currentColor"/>
    </svg>
  </div>
  <div class="container">
    <div class="footer-grid">
      <div class="footer-about">
        <div class="footer-logo">
          <div class="footer-logo-mark">
            <img src="assets/images/yukthatag-icon.webp" alt="Yuktha Associates Group" class="footer-logo-img">
          </div>
          <div class="footer-logo-text">
            <h3>YUKTHA <span>ASSOCIATES GROUP</span></h3>
            <p class="tagline">DEFENSE · TRADE · EXCELLENCE</p>
          </div>
        </div>
        <p class="about-text">
          A diversified powerhouse driving excellence across defense, railway contracting, transformer &amp; electrical equipment supply, stock market partnerships, import-export, real estate, insurance, and financial services.
        </p>
        <div class="footer-social">
          <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
          <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="#" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
        </div>
      </div>

      <div class="footer-links">
        <h4>Quick Links</h4>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/about">About Us</a></li>
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/solutions">Solutions</a></li>
          <li><a routerLink="/team">Our Team</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
        </ul>
      </div>

      <div class="footer-links">
        <h4>Our Services</h4>
        <ul>
          <li><a routerLink="/services" fragment="defense">Defense & Railway Contracting</a></li>
          <li><a routerLink="/services" fragment="transformer">Transformers & Electrical Equipment</a></li>
          <li><a routerLink="/services" fragment="stockmarket">Stock Market Partnerships</a></li>
          <li><a routerLink="/services" fragment="importexport">Import & Export Solutions</a></li>
          <li><a routerLink="/services" fragment="realestate">Real Estate & Home Loans</a></li>
          <li><a routerLink="/services" fragment="insurance">Insurance Services</a></li>
        </ul>
      </div>

      <div class="footer-contact">
        <h4>Contact Info</h4>
        <ul>
          <li>
            <i class="fas fa-map-marker-alt"></i>
            <span>H. No. 19-55/A, Dayanand Nagar, Near Dayanand Nagar Railway Station, Malkajgiri - 500047, Telangana, India</span>
          </li>
          <li>
            <i class="fas fa-phone-alt"></i>
            <div>
              <a href="tel:+918801237799">8801237799</a> |
              <a href="tel:+919959999322">9959999322</a> |
              <a href="tel:+919059012299">9059012299</a>
            </div>
          </li>
          <li>
            <i class="fas fa-envelope"></i>
            <a href="mailto:info&#64;yukthatag.com">info&#64;yukthatag.com</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; 2024 Yuktha Associates Group. All Rights Reserved.</p>
      <div class="footer-bottom-links">
        <a routerLink="/privacy">Privacy Policy</a>
        <a routerLink="/terms">Terms of Service</a>
      </div>
    </div>
  </div>
</footer>
